import { render } from "./BlockDrops.vue?vue&type=template&id=834f2be8&scoped=true"
import script from "./BlockDrops.vue?vue&type=script&lang=js"
export * from "./BlockDrops.vue?vue&type=script&lang=js"

import "./BlockDrops.vue?vue&type=style&index=0&id=834f2be8&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834f2be8"]])

export default __exports__